import React, { useMemo } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import Headline from "../../../shared/NewHeadline";
import { iShopwareCategory } from "../store";
import Sort from "./Sort";

const Row = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin-bottom: 40px;
    justify-content: space-between;
    align-items: start;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        flex-direction: row;
        align-items: end;
        margin-top: 61px;
    `}
`;

interface iProps {
    selectedCategory: string | undefined;
    categories: iShopwareCategory[];
}
const DataControl = ({ selectedCategory, categories }: iProps) => {
    const theme = useTheme();
    const name = useMemo(() => {
        return (
            categories.find((item) => item.id === selectedCategory)?.name ??
            "Suchergebnis"
        );
    }, [selectedCategory, categories]);

    return (
        <Row>
            <Headline
                css={css`
                    ${theme.breakpoints.from.medium.css`
                      margin-bottom: 0;
                    `}
                `}
            >
                {name}
            </Headline>
            <Sort />
        </Row>
    );
};

export default DataControl;
